import React from 'react'
import styled from 'styled-components'
import { CardSection, Section } from '../../../../styled/sections'
import Cards from '../../../../components/ui/card'
import theme from '../../../../styled/theme'
import fonts from '../../../../styled/fonts'
import Medical from '../../../../assets/icons/medical'
import MultiMedicals from '../../../../assets/icons/multi-medicals'
import {Title} from '../../../../components/ui/text'
import { BackPageHeader } from '../../../../components/ui/header'
import { BOOKING_TYPES } from '../constants'

const Container = styled.div`
	width: 100%;
`

const BackHeader = styled(BackPageHeader)`
	p {
		@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
			display: none;
		}
	}
`

const AppointmentOptions = ({ onNext, onSelectBookingType, onBack }) => {
	const cardsList = [
		{
			id: 'single-appointment',
			title: 'Turnos individuales',
			Icon: Medical,
			routes: BOOKING_TYPES.SINGLE
		},
		{
			id: 'multiple-appointment',
			title: 'Múltiples turnos',
			Icon: MultiMedicals,
			routes: BOOKING_TYPES.MULTIPLE
		}
	]

	const handleSelectMode = mode => {
		if (onSelectBookingType) {
			onSelectBookingType(mode)
		}
		onNext({ bookingType: mode })
	}

	return (
		<Container>
			<BackHeader
				onBack={onBack}
				hideBackOnMobile={false}
				title={
					<Title
						size={fonts.fontSizes.xxl}
						color={theme.colors.text.titleText}
						margin="0 0 24px 0"
						fontWeight={fonts.fontWeight.semibold}
					>
						¿Qué tipo de turno?
					</Title>
				}
			/>
			<Section>
				<CardSection>
					<Cards
						iconColor={theme.colors.brand.green}
						list={cardsList}
						onClick={handleSelectMode}
						mobileColumns={1}
						fullMobileCard={true}
					/>
				</CardSection>
			</Section>
		</Container>
	)
}

export default AppointmentOptions